import { screenSizes } from "@contracts/screenSize";

// Types
import { ScreenSize } from "@contracts/screenSize";

export function isScreenBigger(dynamicValue: ScreenSize, staticValue: ScreenSize): boolean {
  return screenSizes.findIndex(s => s === dynamicValue) > screenSizes.findIndex(s => s === staticValue);
}
export function isScreenSmaller(dynamicValue: ScreenSize, staticValue: ScreenSize): boolean {
  return screenSizes.findIndex(s => s === dynamicValue) < screenSizes.findIndex(s => s === staticValue);
}

export function isScreenEqualOrBigger(dynamicValue: ScreenSize, staticValue: ScreenSize): boolean {
  return screenSizes.findIndex(s => s === dynamicValue) >= screenSizes.findIndex(s => s === staticValue);
}
export function isScreenEqualOrSmaller(dynamicValue: ScreenSize, staticValue: ScreenSize): boolean {
  return screenSizes.findIndex(s => s === dynamicValue) <= screenSizes.findIndex(s => s === staticValue);
}

export default {
  isScreenBigger,
  isScreenSmaller,

  isScreenEqualOrBigger,
  isScreenEqualOrSmaller,
};
